import { Redirect } from 'react-router-dom'

const AdAccountListRedirect = () => <Redirect to="/adaccount/all" />
export default AdAccountListRedirect
